import { CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import ActionTable from "../../components/table/ActionTable";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";

export default function Permissoes({ history, location }) {
  const [carregando, setCarregando] = useState(false);
  const [dados, setDados] = useState({
    grupoId: 0,
    sistema: 1,
  });
  const [comboGrupos, setComboGrupos] = useState([]);
  const [menus, setMenus] = useState([]);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    carregarCombo();
  }, []);

  const carregarCombo = () => {
    api
      .get("grupos/listar")
      .then((res) => {
        setComboGrupos(res);
      })
      .catch((err) => {
        notification("error", "Não foi possível listar grupos");
      });
  };

  const listar = (params) => {
    let dadosParams = params;
    setDados(dadosParams);
    api
      .get("permissoes/listar", params)
      .then((res) => {
        tratarPermissoes(res);
      })
      .catch((err) => {
        notification("error", "Não foi possível listar permissões");
      });
  };

  const filtros = {
    title: "Selecionar Grupo",
    form: {
      grupoId: {
        label: "Grupo",
        type: "select",
        space: 6,
        emptyItem: true,
        array: {
          data: comboGrupos,
          value: "id",
          desc: "nome",
        },
        value: dados.grupoId,
      },
      sistema: {
        label: "Sistema",
        type: "select",
        emptyItem: true,
        space: 6,
        options: [
          {
            value: 0,
            desc: "(Todos)",
          },
          {
            value: 1,
            desc: "Painel Administrativo",
          },
          {
            value: 2,
            desc: "Painel Escolas",
          },
        ],
        value: dados.sistema,
      },
    },

    submit: {
      label: "Buscar",
      action: listar,
    },

    // urlParams: true,
    // history,
    // location,
  };

  const tratarPermissoes = (registros) => {
    let paiId = 0;
    let menus = [];
    let grupo = [];

    registros.forEach((r) => {
      if (r.menuPaiId !== paiId) {
        paiId = r.menuPaiId;

        grupo = [];

        menus.push(grupo);
      }

      r.permissao = r.permissaoGrupoId > 0;

      grupo.push(r);
    });
    setMenus(menus);
  };

  const alternarPermisao = (registro, checked) => {
    if (checked) {
      api
        .put("permissoes/inserir", {
          grupoId: dados.grupoId,
          menuId: registro.menuFilhoId,
        })
        .then((res) => {
          notification("success", "Permissão salva!");
          listar(dados);
        })
        .catch((err) => {
          notification("error", "Não foi possível alternar permissões");
        });
    } else {
      api
        .delete("permissoes/remover", {
          grupoId: dados.grupoId,
          menuId: registro.menuFilhoId,
        })
        .then((res) => {
          notification("success", "Permissão salva!");
          listar(dados);
        })
        .catch((err) => {
          notification("error", "Não foi possível alternar permissões");
        });
    }
  };

  const tabelas = [];

  menus.forEach((grupo) => {
    const tableStructure = {
      title: grupo[0].menuPaiNome,
      array: grupo,
      key: "grupoId",
      columns: [
        {
          name: "menuFilhoNome",
          label: "Nome",
          style: { fontWeight: "bolder" },
        },
        {
          name: "permissao",
          label: "Permissão",
          checkbox: true,
          onCheck: alternarPermisao,
        },
      ],
    };

    tabelas.push(tableStructure);
  });

  return (
    <div>
      <Form formData={filtros} />
      <br />

      {carregando ? (
        <CircularProgress />
      ) : (
        tabelas.map((tabela, key) => (
          <>
            <ActionTable structure={tabela} key={key} />
            <br />
          </>
        ))
      )}
    </div>
  );
}
